import List from '../views/corporations/list'
import Show from '../views/corporations/show'
export default [
    {
        path: '/admin/corporations',
        name: 'corporations',
        component: List,
        authorize: 1
    },
    {
        path: '/admin/corporation/:id',
        name: 'corporation-show',
        component: Show,
    }
]
